import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { color } from '../templates/Ui';
const Text = styled.span `
    display: block;
    color: ${color.gray.darkest};
    font-size: 15px;
    font-weight: 400;
    margin-left: 5px;
`;
const Color = styled.div `
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: ${props => props.color};
`;
const StyledItem = styled.div `
    display: none;
    height: 20px;
    margin-left: 40px;

    @media only screen and (min-width: 768px) {
        display: flex;
        align-items: center;
    }
`;
const LegendItem = ({ label, color }) => {
    return (_jsxs(StyledItem, { children: [_jsx(Color, { color: color }), _jsx(Text, { children: label })] }));
};
export default LegendItem;
